<div class="overlay"></div>
<nz-spin nzSimple class="spinner"></nz-spin>